
export default class V2EndingNodes {

  static SECRET_ENDING = {
    secret_1: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/backdrop/stake_empty.ktx2',
      storyAction: { type: 'addState', value: "ENDING_S_SECRET_ENDING" },
      nextDialogId : "secret_2",
      cinematic : true,
      autoplay : 3,
      music : "music_secret_ending"
    },
    secret_2: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/stake_yanf.ktx2',
      nextDialogId : "secret_3",
      cinematic : true,
      autoplay : 3,
    },
    secret_3: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      // backgroundImage: '/assets/backdrop/stake_on_fire.ktx2',
      cinematic: true,
      fade : true,
      backgroundAnimate: ['/assets/backdrop/stake_on_fire.ktx2', '/assets/backdrop/stake_on_fire_2.ktx2'],
      sfx : "burn",
      nextDialogId : "secret_4",
      autoplay : 3,
    },
    secret_4: {
      id: 'secret_1',
      speaker: '',
      text: `Yan dibakar hidup-hidup oleh orang-orang desa`,
      backgroundImage: '/assets/backdrop/stake_on_fire.ktx2',
      backgroundAnimate: ['/assets/backdrop/stake_on_fire.ktx2', '/assets/backdrop/stake_on_fire_2.ktx2'],
      nextDialogId : "secret_5",
      fade : true,
      cinematic : true,
      autoplay : 3,
    },
    secret_5: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      nextDialogId : "secret_6",
      cinematic : true,
      autoplay : 3,
    },

    secret_6: {
      id: 'gen_1',
      speaker: '',
      text: `Di hari itu, Yan mati terbakar`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "secret_7",
      autoplay : 3,
    },
    secret_7: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "secret_8",
      autoplay : 1,
    },
    secret_8: {
      id: 'gen_1',
      speaker: '',
      text: `Orang desa percaya Yan mati dan sepenuhnya menjadi abu`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "secret_9",
      autoplay : 3,
    },
    secret_9: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "secret_10",
      autoplay : 1,
    },
    secret_10: {
      id: 'gen_1',
      speaker: '',
      text: `Sejak saat itu, desa aman dari serangan Songko`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "secret_11",
      autoplay : 3,
    },
    secret_11: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "secret_12",
      autoplay : 1,
    },
    secret_12: {
      id: 'gen_1',
      speaker: '',
      text: `Bersambung`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "secret_13",
      autoplay : 3,
    },
    secret_13: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "secret_14",
      autoplay : 1,
    },
    secret_14: {
      id: 'secret_1',
      speaker: '',
      cinematic : true,
      text: ``,
      backgroundImage: '/assets/cutscene/D2_songko_attack.ktx2',
      nextDialogId: "secret_15",
      autoplay : 0.1,
      sfx : "static"
    },
    secret_15: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "secret_16",
      autoplay : 2,
    },
    secret_16: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/1.ktx2',
      backgroundAnimate: ['/assets/cutscene/secret/1.ktx2', '/assets/cutscene/secret/1b.ktx2'],
      nextDialogId : "secret_17",
      cinematic : true,
      autoplay : 3,
    },
    secret_17: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/2.ktx2',
      backgroundAnimate: ['/assets/cutscene/secret/2.ktx2', '/assets/cutscene/secret/2b.ktx2'],
      nextDialogId : "secret_18",
      cinematic : true,
      autoplay : 3,
    },
    secret_18: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/1.ktx2',
      backgroundAnimate: ['/assets/cutscene/secret/3.ktx2', '/assets/cutscene/secret/3b.ktx2'],
      nextDialogId : "secret_19",
      cinematic : true,
      autoplay : 3,
    },
    secret_19: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/4.ktx2',
      backgroundAnimate: ['/assets/cutscene/secret/4.ktx2', '/assets/cutscene/secret/4b.ktx2'],
      nextDialogId : "secret_20",
      cinematic : true,
      autoplay : 3,
    },
    secret_20: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/5.ktx2',
      backgroundAnimate: ['/assets/cutscene/secret/5.ktx2', '/assets/cutscene/secret/5b.ktx2'],
      nextDialogId : "secret_21",
      cinematic : true,
      autoplay : 3,
    },
    secret_21: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/6.ktx2',
      backgroundAnimate: ['/assets/cutscene/secret/6.ktx2', '/assets/cutscene/secret/6b.ktx2'],
      nextDialogId : "secret_22",
      cinematic : true,
      autoplay : 3,
    },
    secret_22: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "secret_23",
      autoplay : 1.5,
    },
    secret_23: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/7a.ktx2',
      nextDialogId : "secret_24",
      cinematic : true,
      autoplay : 3,
    },
    secret_24: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/7b.ktx2',
      nextDialogId : "secret_25",
      cinematic : true,
      autoplay : 3,
    },
    secret_25: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/9a.ktx2',
      nextDialogId : "secret_26",
      cinematic : true,
      autoplay : 3,
    },
    secret_26: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/9b.ktx2',
      nextDialogId : "secret_27",
      cinematic : true,
      autoplay : 3,
    },
    secret_27: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/9c.ktx2',
      nextDialogId : "secret_28",
      cinematic : true,
      autoplay : 3,
    },
    secret_28: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/10a.ktx2',
      backgroundAnimate: ['/assets/cutscene/secret/10a.ktx2', '/assets/cutscene/secret/10b.ktx2'],
      nextDialogId : "secret_29",
      cinematic : true,
      autoplay : 3,
    },
    secret_29: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/11a.ktx2',
      backgroundAnimate: ['/assets/cutscene/secret/11a.ktx2', '/assets/cutscene/secret/11b.ktx2'],
      nextDialogId : "secret_30",
      cinematic : true,
      autoplay : 3,
    },
    secret_30: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      autoplay : 3,
      cinematic : true,
      isEnd: true,
      isGameOver: true
    },
  }

  static GAME_OVER_ENDING = {
    bad_1: {
      id: 'secret_1',
      speaker: 'Elsa',
      music : 'music_bad_chase_scene',
      text: `Saatnya kita meninggalkan tempat ini`,
      fade: true,
      characterImage: '/assets/character/v2/elsa.png',
      backgroundImage: '/assets/backdrop/portal.png',
      storyAction: { type: 'addState', value: "ENDING_F_GAME_OVER_ENDING" },
      nextDialogId: "bad_2",
    },
    bad_2: {
      id: 'secret_1',
      speaker: 'Elsa',
      text: `Ayo Yan, saatnya kita pergi, Ikuti aku!`,
      fade: true,
      characterImage: '/assets/character/v2/elsa_a.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: "bad_2w",
    },
    bad_2w: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: "bad_3",
      walk: {
        x : 20, y: 20,
        frames : ['/assets/backdrop/portal.png','/assets/cutscene/portal_inverted.png','/assets/backdrop/portal.png',],
        sfx : ["running","doorKnock","running"]
      },
      autoplay : 3.5
    },
    bad_3: {
      id: 'secret_1',
      speaker: 'Elsa',
      text: `Apa kamu mendengar suara itu?`,
      characterImage: '/assets/character/v2/elsa_p.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: "bad_4",
    },
    bad_4: {
      id: 'secret_1',
      speaker: 'Elsa',
      text: `Apakah itu suara orang desa mengejar kita?`,
      characterImage: '/assets/character/v2/elsa_p.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: "bad_5",
    },
    bad_5: {
      id: 'secret_1',
      speaker: 'Elsa',
      text: `Kita harus terus berlari Yan, jalan keluar sudah dekat!`,
      characterImage: '/assets/character/v2/elsa_a.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: "bad_7",
    },
    bad_7: {
      id: 'secret_1',
      speaker: 'Elsa',
      text: `Ikuti Aku`,
      characterImage: '/assets/character/v2/elsa_a.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: "bad_8",
    },
    bad_8: {
      id: 'secret_1',
      text : "",
      speaker : "",
      backgroundImage: '/assets/backdrop/portal.png',
      walk: {
        x : 20, y: 20,
        frames : ['/assets/backdrop/portal.png','/assets/cutscene/portal_inverted.png',],
        sfx : ["running","running"]
      },
      nextDialogId: "bad_9",
      autoplay : 2,
    },
    bad_9: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/black.ktx2',
      sfx : "doorSlam",
      nextDialogId: "bad_10",
      autoplay : 1,
    },
    bad_10: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/black.ktx2',
      nextDialogId: "fall_1",
      autoplay : 3,
      sfx : "tinnitus",
      bpm : 80
    },
    fall_1: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/ground_a_songko.png',
      nextDialogId: "fall_2",
      autoplay : 8,
      blink : true,
      fade : true,
    },
    fall_2: {
      id: 'secret_1',
      speaker: 'Elsa',
      text: `Yan!! Yan!! Kamu dimana??`,
      backgroundImage: '/assets/cutscene/ground_a_nothing.png',
      nextDialogId: "fall_4",
      autoplay : 8,
      // blink : true,
      fade : true,
    },
    fall_4: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/ground_scare_1.jpg',
      nextDialogId: "fall_4a",
      autoplay : 0.3,
      cinematic :true,
      sfx: "static",
    },
    fall_4a: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/ground_a_nothing.png',
      nextDialogId: "fall_4b",
      autoplay : 0.3,
      cinematic :true,
    },
    fall_4b: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/ground_scare_2.jpg',
      nextDialogId: "fall_5",
      autoplay : 0.6,
      cinematic :true,
    },

    fall_5: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/black.ktx2',
      // nextDialogId: "bad_11",
      autoplay : 3,
      cinematic : true,
      isEnd : true,
      isGameOver :true,
      music : "standingby"
    },
  }

  static GOOD_ENDING = {
    good_1: {
      id: 'secret_1',
      speaker: 'Nenek',
      text: `Teganya kalian berbuat ini ke orang tua`,
      fade: true,
      backgroundImage: '/assets/cutscene/stake_nenek.ktx2',
      nextDialogId: "good_2",
      storyAction: { type: 'addState', value: "ENDING_A_GOOD_ENDING" },
      autoplay: 3,
      music : "music_happy_a"
    },
    good_2: {
      id: 'secret_1',
      speaker: 'Nenek',
      text: `Kalian semua akan menyesal telah melakukan ini!`,
      fade: true,
      sfx : "monsterLaugh",
      backgroundImage: '/assets/cutscene/stake_nenek.ktx2',
      nextDialogId: "good_3",
      autoplay: 3
    },
    good_3: {
      id: 'secret_1',
      speaker: 'Romo Darius',
      text: `Suara apa itu? Itu bukan manusia!`,
      characterImage: '/assets/character/v2/darius.png',
      backgroundImage: '/assets/cutscene/stake_nenek.ktx2',
      nextDialogId: "good_4",
      autoplay: 3
    },
    good_4: {
      id: 'secret_1',
      speaker: 'Ato',
      text: `Semua, cepat masukan api!`,
      characterImage: '/assets/character/v2/ato.png',
      backgroundImage: '/assets/cutscene/stake_nenek.ktx2',
      nextDialogId: "good_5",
      autoplay: 3
    },
    good_5: {
      id: 'secret_1',
      speaker: '',
      fade: true,
      cinematic: true,
      text: ``,
      sfx : "burn",
      backgroundImage: '/assets/backdrop/stake_on_fire.ktx2',
      backgroundAnimate: ['/assets/backdrop/stake_on_fire.ktx2', '/assets/backdrop/stake_on_fire_2.ktx2'],
      nextDialogId: "good_6",
      autoplay: 3
    },
    good_6: {
      id: 'secret_1',
      speaker: '',
      fade: true,
      cinematic: true,
      text: ``,
      sfx : "monsterLaugh",
      backgroundImage: '/assets/cutscene/burning_shadow_b.ktx2',
      backgroundAnimate: ['/assets/cutscene/burning_shadow_b.ktx2', '/assets/cutscene/burning_shadow_a.ktx2'],
      nextDialogId: "good_7",
      autoplay: 3
    },
    good_7: {
      id: 'secret_1',
      speaker: '',
      fade: true,
      cinematic: true,
      text: ``,
      backgroundImage: '/assets/cutscene/black.ktx2',
      nextDialogId: "good_8",
      autoplay: 3
    },
    good_8 : {
      id: 'secret_1',
      speaker: '',
      fade: true,
      cinematic: true,
      text: `Sejak saat itu desa aman dari ancaman Songko`,
      backgroundImage: '/assets/cutscene/black.ktx2',
      nextDialogId: "good_9",
      autoplay: 3,
      music : "music_happy_b",
    },
    good_9 : {
      id: 'secret_1',
      speaker: '',
      fade: true,
      cinematic: true,
      text: `Yan dirayakan oleh desa sebagai pahlawan`,
      backgroundImage: '/assets/cutscene/happy_ending.png',
      nextDialogId: "good_9b",
      autoplay: 3
    },
    good_9b : {
      id: 'secret_1',
      speaker: '',
      fade: true,
      cinematic: true,
      text: ``,
      backgroundImage: '/assets/cutscene/happy_ending.png',
      nextDialogId: "good_10",
      autoplay: 1
    },
    good_10 : {
      id: 'secret_1',
      speaker: '',
      fade: true,
      cinematic: true,
      text: `Dia kembali ke kota untuk melanjutkan sekolahnya`,
      backgroundImage: '/assets/cutscene/happy_ending.png',
      nextDialogId: "good_11a",
      autoplay: 3
    },
    good_11a : {
      id: 'secret_1',
      speaker: '',
      fade: true,
      cinematic: true,
      text: ``,
      backgroundImage: '/assets/cutscene/black.ktx2',
      nextDialogId: "good_11",
      autoplay: 1
    },
    good_11 : {
      id: 'secret_1',
      speaker: '',
      fade: true,
      cinematic: true,
      text: `Bersambung`,
      backgroundImage: '/assets/cutscene/black.ktx2',
      nextDialogId: "secret_2",
      isEnd : true,
      isGameOver : true,
    },
  }

  static ELSA_FAIL_DEFEND_ENDING = {
    efed_1: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/backdrop/stake_empty.ktx2',
      nextDialogId : "efed_2",
      storyAction: { type: 'addState', value: "ENDING_D_FAIL_SELF_OR_ELSA_ENDING" },
      autoplay : 2,
      bpm : 1,
      music : "music_happy_a"
    },
    efed_2: {
      id: 'gen_1',
      speaker: 'Elsa',
      text: `Tolong!!`,
      backgroundImage: '/assets/backdrop/stake_elsa.ktx2',
      nextDialogId : "efed_3",
      autoplay : 2,
      fade : true,
    },
    efed_3: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/backdrop/stake_elsa.ktx2',
      cinematic : true,
      nextDialogId : "efed_4",
      autoplay : 2,
    },
    efed_4: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/backdrop/stake_elsa.ktx2',
      backgroundAnimate: ['/assets/backdrop/stake_on_fire.ktx2', '/assets/backdrop/stake_on_fire_2.ktx2'],
      cinematic : true,
      nextDialogId : "efed_5",
      // autoplay : 3,
    },
    efed_5: {
      id: 'gen_1',
      speaker: '',
      text: `Elsa dibakar hidup-hidup oleh orang desa`,
      fade : true,
      backgroundImage: '/assets/backdrop/stake_on_fire.ktx2',
      backgroundAnimate: ['/assets/backdrop/stake_on_fire.ktx2', '/assets/backdrop/stake_on_fire_2.ktx2'],
      cinematic : true,
      nextDialogId : "efed_6",
      autoplay : 3,
    },
    efed_6: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "efed_7",
      autoplay : 3,
    },
    efed_7: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/sad_ending_yanf.png',
      cinematic : true,
      nextDialogId : "efed_8",
      autoplay : 3,
    },
    efed_8: {
      id: 'gen_1',
      speaker: '',
      text: `Yan pun kembali ke kota \ndan bersumpah untuk tidak kembali ke desa.`,
      fade : true,
      backgroundImage: '/assets/cutscene/sad_ending_yanf.png',
      cinematic : true,
      nextDialogId : "efed_9",
      autoplay : 3,
    },
    efed_9: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/backdrop/portal.png',
      cinematic : true,
      nextDialogId : "efed_10",
      autoplay : 3,
    },
    efed_10: {
      id: 'gen_1',
      speaker: '',
      text: `Sejak saat itu, desa aman dari serangan Songko`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "efed_11",
      autoplay : 3,
    },
    efed_11: {
      id: 'gen_1',
      speaker: '',
      text: `Bersambung`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      isEnd : true,
      isGameOver : true,
    },
  }

  static ELSA_WRONG_ENDING = {
    ewe_1: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/backdrop/stake_empty.ktx2',
      storyAction: { type: 'addState', value: "ENDING_B_STILL_SURVIVE_ENDING" },
      nextDialogId : "ewe_2",
      autoplay : 2,
      music : "music_happy_a"
    },
    ewe_2: {
      id: 'gen_1',
      speaker: 'Elsa',
      text: `Tolong!!`,
      backgroundImage: '/assets/backdrop/stake_elsa.ktx2',
      nextDialogId : "ewe_3",
      autoplay : 2,
      fade : true,
    },
    ewe_3: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/backdrop/stake_elsa.ktx2',
      cinematic : true,
      nextDialogId : "ewe_4",
      autoplay : 2,
    },
    ewe_4: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/backdrop/stake_elsa.ktx2',
      backgroundAnimate: ['/assets/backdrop/stake_on_fire.ktx2', '/assets/backdrop/stake_on_fire_2.ktx2'],
      cinematic : true,
      nextDialogId : "ewe_5",
      autoplay : 3,
    },
    ewe_5: {
      id: 'gen_1',
      speaker: '',
      text: `Elsa dibakar hidup-hidup oleh orang desa`,
      fade : true,
      backgroundImage: '/assets/backdrop/stake_on_fire.ktx2',
      backgroundAnimate: ['/assets/backdrop/stake_on_fire.ktx2', '/assets/backdrop/stake_on_fire_2.ktx2'],
      cinematic : true,
      nextDialogId : "ewe_6",
      autoplay : 3,
    },
    ewe_6: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "ewe_7",
      autoplay : 3,
    },
    ewe_7: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/sad_ending_yanf.png',
      cinematic : true,
      nextDialogId : "ewe_8",
      autoplay : 3,
    },
    ewe_8: {
      id: 'gen_1',
      speaker: '',
      text: `Yan pun kembali ke kota`,
      fade : true,
      backgroundImage: '/assets/cutscene/sad_ending_yanf.png',
      cinematic : true,
      nextDialogId : "ewe_9",
      autoplay : 3,
    },
    ewe_9: {
      id: 'gen_1',
      speaker: '',
      text: `Dia selalu merasa bersalah atas kematian Elsa`,
      fade : true,
      backgroundImage: '/assets/cutscene/sad_ending_yanf.png',
      cinematic : true,
      nextDialogId : "ewe_10",
      autoplay : 3,
    },
    ewe_10: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/backdrop/portal.png',
      cinematic : true,
      nextDialogId : "ewe_11",
      autoplay : 3,
    },
    ewe_11: {
      id: 'gen_1',
      speaker: '',
      text: `Sejak saat itu, desa aman dari serangan Songko`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "ewe_12",
      autoplay : 3,
    },
    ewe_12: {
      id: 'gen_1',
      speaker: '',
      text: `Tapi Yan selalu berpikir`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "ewe_13",
      autoplay : 2,
    },
    ewe_13: {
      id: 'gen_1',
      speaker: '',
      text: `Apakah benar yang dibakar dihari itu adalah Songko?`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "ewe_14",
      autoplay : 3,
    },
    ewe_14: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "ewe_15",
      autoplay : 2,
    },
    ewe_15: {
      id: 'gen_1',
      speaker: '',
      text: `Bersambung`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      isEnd : true,
      isGameOver : true,
    },
  }

  static BUNGA_WRONG_ENDING = {
    bwe_1: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/backdrop/stake_empty.ktx2',
      storyAction: { type: 'addState', value: "ENDING_B_STILL_SURVIVE_ENDING" },
      nextDialogId : "bwe_2",
      autoplay : 2,
      music : "music_happy_a"
    },
    bwe_2: {
      id: 'gen_1',
      speaker: 'Bunga',
      text: `Tolong!!`,
      backgroundImage: '/assets/cutscene/stake_bunga.ktx2',
      nextDialogId : "bwe_3",
      autoplay : 2,
      fade : true,
    },
    bwe_3: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/stake_bunga.ktx2',
      cinematic : true,
      nextDialogId : "bwe_4",
      autoplay : 2,
    },
    bwe_4: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/stake_bunga.ktx2',
      backgroundAnimate: ['/assets/backdrop/stake_on_fire.ktx2', '/assets/backdrop/stake_on_fire_2.ktx2'],
      cinematic : true,
      nextDialogId : "bwe_5",
      autoplay : 3,
    },
    bwe_5: {
      id: 'gen_1',
      speaker: '',
      text: `Bunga dibakar hidup-hidup oleh orang desa`,
      fade : true,
      backgroundImage: '/assets/backdrop/stake_on_fire.ktx2',
      backgroundAnimate: ['/assets/backdrop/stake_on_fire.ktx2', '/assets/backdrop/stake_on_fire_2.ktx2'],
      cinematic : true,
      nextDialogId : "bwe_6",
      autoplay : 3,
    },
    bwe_6: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "bwe_7",
      autoplay : 3,
    },
    bwe_7: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/sad_ending_yanf.png',
      cinematic : true,
      nextDialogId : "bwe_8",
      autoplay : 3,
    },
    bwe_8: {
      id: 'gen_1',
      speaker: '',
      text: `Yan pun kembali ke kota`,
      fade : true,
      backgroundImage: '/assets/cutscene/sad_ending_yanf.png',
      cinematic : true,
      nextDialogId : "bwe_9",
      autoplay : 3,
    },
    bwe_9: {
      id: 'gen_1',
      speaker: '',
      text: `Dia selalu merasa bersalah atas kematian Bunga`,
      fade : true,
      backgroundImage: '/assets/cutscene/sad_ending_yanf.png',
      cinematic : true,
      nextDialogId : "bwe_10",
      autoplay : 3,
    },
    bwe_10: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/backdrop/portal.png',
      cinematic : true,
      nextDialogId : "bwe_11",
      autoplay : 3,
    },
    bwe_11: {
      id: 'gen_1',
      speaker: '',
      text: `Sejak saat itu, desa aman dari serangan Songko`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "bwe_12",
      autoplay : 3,
    },
    bwe_12: {
      id: 'gen_1',
      speaker: '',
      text: `Tapi Yan selalu berpikir`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "bwe_13",
      autoplay : 2,
    },
    bwe_13: {
      id: 'gen_1',
      speaker: '',
      text: `Apakah benar yang dibakar dihari itu adalah Songko?`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "bwe_14",
      autoplay : 3,
    },
    bwe_14: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "bwe_15",
      autoplay : 2,
    },
    bwe_15: {
      id: 'gen_1',
      speaker: '',
      text: `Bersambung`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      isEnd : true,
      isGameOver : true,
    },
  }

  static HOLGA_WRONG_ENDING = {
    hwe_1: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/backdrop/stake_empty.ktx2',
      storyAction: { type: 'addState', value: "ENDING_B_STILL_SURVIVE_ENDING" },
      nextDialogId : "hwe_2",
      autoplay : 2,
      music : "music_happy_a"
    },
    hwe_2: {
      id: 'gen_1',
      speaker: 'Holga',
      text: `Berani berani nya kalian!!`,
      backgroundImage: '/assets/cutscene/stake_holga.ktx2',
      nextDialogId : "hwe_3",
      autoplay : 2,
      fade : true,
    },
    hwe_3: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/stake_holga.ktx2',
      cinematic : true,
      nextDialogId : "hwe_4",
      autoplay : 2,
    },
    hwe_4: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/stake_holga.ktx2',
      backgroundAnimate: ['/assets/backdrop/stake_on_fire.ktx2', '/assets/backdrop/stake_on_fire_2.ktx2'],
      cinematic : true,
      nextDialogId : "hwe_5",
      autoplay : 3,
    },
    hwe_5: {
      id: 'gen_1',
      speaker: '',
      text: `Holga dibakar hidup-hidup oleh orang desa`,
      fade : true,
      backgroundImage: '/assets/backdrop/stake_on_fire.ktx2',
      backgroundAnimate: ['/assets/backdrop/stake_on_fire.ktx2', '/assets/backdrop/stake_on_fire_2.ktx2'],
      cinematic : true,
      nextDialogId : "hwe_6",
      autoplay : 3,
    },
    hwe_6: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "hwe_7",
      autoplay : 3,
    },
    hwe_7: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/sad_ending_yanf.png',
      cinematic : true,
      nextDialogId : "hwe_8",
      autoplay : 3,
    },
    hwe_8: {
      id: 'gen_1',
      speaker: '',
      text: `Yan pun kembali ke kota`,
      fade : true,
      backgroundImage: '/assets/cutscene/sad_ending_yanf.png',
      cinematic : true,
      nextDialogId : "hwe_9",
      autoplay : 3,
    },
    hwe_9: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/backdrop/portal.png',
      cinematic : true,
      nextDialogId : "hwe_10",
      autoplay : 3,
    },
    hwe_10: {
      id: 'gen_1',
      speaker: '',
      text: `Sejak saat itu, desa aman dari serangan Songko`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "hwe_11",
      autoplay : 3,
    },
    hwe_11: {
      id: 'gen_1',
      speaker: '',
      text: `Tapi Yan selalu berpikir`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "hwe_12",
      autoplay : 2,
    },
    hwe_12: {
      id: 'gen_1',
      speaker: '',
      text: `Apakah benar yang dibakar dihari itu adalah Songko?`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "hwe_13",
      autoplay : 3,
    },
    hwe_13: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "hwe_14",
      autoplay : 2,
    },
    hwe_14: {
      id: 'gen_1',
      speaker: '',
      text: `Bersambung`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      isEnd : true,
      isGameOver : true,
    },
  }

  static SELF_DEATH_ENDING = {
    sde_1: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/backdrop/stake_empty.ktx2',
      nextDialogId : "sde_2",
      cinematic : true,
      autoplay : 3,
      storyAction: { type: 'addState', value: "ENDING_D_FAIL_SELF_OR_ELSA_ENDING" },
      music : "music_happy_a"
    },
    sde_2: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/stake_yanf.ktx2',
      nextDialogId : "sde_3",
      cinematic : true,
      autoplay : 3,
    },
    sde_3: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      // backgroundImage: '/assets/backdrop/stake_on_fire.ktx2',
      cinematic: true,
      fade : true,
      backgroundAnimate: ['/assets/backdrop/stake_on_fire.ktx2', '/assets/backdrop/stake_on_fire_2.ktx2'],
      sfx : "burn",
      nextDialogId : "sde_4",
      autoplay : 3,
    },
    sde_4: {
      id: 'secret_1',
      speaker: '',
      text: `Yan dibakar hidup-hidup oleh orang-orang desa`,
      backgroundImage: '/assets/backdrop/stake_on_fire.ktx2',
      backgroundAnimate: ['/assets/backdrop/stake_on_fire.ktx2', '/assets/backdrop/stake_on_fire_2.ktx2'],
      nextDialogId : "sde_5",
      fade : true,
      cinematic : true,
      autoplay : 3,
    },
    sde_5: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      nextDialogId : "sde_6",
      cinematic : true,
      autoplay : 3,
    },
    sde_6: {
      id: 'gen_1',
      speaker: '',
      text: `Di hari itu, Yan mati terbakar`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "sde_7",
      autoplay : 3,
    },
    sde_7: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "sde_8",
      autoplay : 1,
    },
    sde_8: {
      id: 'secret_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/secret/1.ktx2',
      backgroundAnimate: ['/assets/cutscene/secret/1.ktx2', '/assets/cutscene/secret/1b.ktx2'],
      nextDialogId : "sde_9",
      cinematic : true,
      autoplay : 4,
    },
    sde_9: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "sde_10",
      autoplay : 1,
    },
    sde_10: {
      id: 'gen_1',
      speaker: '',
      text: `Orang desa percaya Yan mati dan sepenuhnya menjadi abu`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "sde_11",
      autoplay : 3,
    },
    sde_11: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "sde_12",
      autoplay : 1,
    },
    sde_12: {
      id: 'gen_1',
      speaker: '',
      text: `Sejak saat itu, desa aman dari serangan Songko`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "sde_13",
      autoplay : 3,
    },
    sde_13: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "sde_14",
      autoplay : 1,
    },
    sde_14: {
      id: 'gen_1',
      speaker: '',
      text: `Semua orang yakin, Yan adalah wujud asli Songko`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "sde_15",
      autoplay : 3,
    },
    sde_15: {
      id: 'gen_1',
      speaker: '',
      text: ``,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "sde_16",
      autoplay : 1,
    },
    sde_16: {
      id: 'gen_1',
      speaker: '',
      text: `Bersambung`,
      fade : true,
      backgroundImage: '/assets/cutscene/black.ktx2',
      cinematic : true,
      nextDialogId : "secret_13",
      autoplay : 3,
      isGameOver : true,
      isEnd : true,
    },
  }

}